import { render } from "./CoursesReleasesGrid.vue?vue&type=template&id=676edef5&scoped=true"
import script from "./CoursesReleasesGrid.vue?vue&type=script&lang=js"
export * from "./CoursesReleasesGrid.vue?vue&type=script&lang=js"

import "./CoursesReleasesGrid.vue?vue&type=style&index=0&id=676edef5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676edef5"]])

export default __exports__